import React, { useState, useEffect } from 'react';

const OtpTimer = ({ duration = 600, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    if (timeLeft <= 0) {
      if (onExpire) onExpire(); // Optional callback on expiry
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [timeLeft, onExpire]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <div style={{ fontSize: '14px', marginTop:10}}>
      OTP Expires in: {formatTime(timeLeft)} 
    </div>
  );
};

export default OtpTimer;
